const formatSerialNumbers = (textareaValue: string): string[] => {
	return textareaValue
		.split(/[\n, ]+/)
		.map((serial) => serial.trim())
		.filter((serial) => serial.length > 0);
};

export default formatSerialNumbers